import { QUESTION_REVIEW_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { WorkflowStepCode } from '@exam-management/graphql';
import { TaskOverdueDialog, type TaskOverdueDialogVariant } from '@exam-management/task-management';
import { Button, CheckCircleOutlineRoundedIcon, Divider } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useState } from 'react';

import { useQuestionReviewTaskDetails } from '../../providers';
import { FinishQuestionReviewMainTaskModal } from '../finish-question-review-main-task-modal';
import { FinishQuestionReviewSubtaskModal } from '../finish-question-review-subtask-modal';

export default function QuestionReviewTaskDetailsPageHeaderFinishTaskButton() {
  const { taskDetails, workflowRoles, checkUserAbility } = useQuestionReviewTaskDetails();

  const [isFinishMainTaskModalOpen, finishMainTaskModalHandlers] = useDisclosure();
  const [isFinishSubtaskModalOpen, finishSubtaskModalHandler] = useDisclosure();
  const [isOverdueDialogOpen, overdueDialogHandlers] = useDisclosure();
  const [overdueVariant, setOverdueVariant] = useState<TaskOverdueDialogVariant>('mark-as-done');

  const handleSubtaskOverdue = () => {
    setOverdueVariant('submit-review');
    overdueDialogHandlers.open();
  };

  const handleMainTaskOverdue = () => {
    setOverdueVariant('mark-as-done');
    overdueDialogHandlers.open();
  };

  const hasAccessToFinishTask = checkUserAbility('FINISH_TASK');

  const taskStatus = taskDetails.currentWorkflowStep.code;

  const canFinishSubtask =
    workflowRoles.isAssignee && taskStatus === WorkflowStepCode.QuestionReviewInReview;
  const canFinishMainTask =
    workflowRoles.isOwner && taskStatus === WorkflowStepCode.QuestionReviewReviewed;

  const handleClickFinishTask = () => {
    if (canFinishSubtask) {
      finishSubtaskModalHandler.open();
      return;
    }
    if (canFinishMainTask) {
      finishMainTaskModalHandlers.open();
      return;
    }
  };

  if (!hasAccessToFinishTask) {
    return null;
  }

  return (
    <>
      <Divider orientation='vertical' variant='middle' flexItem />
      <Button
        onClick={handleClickFinishTask}
        startIcon={<CheckCircleOutlineRoundedIcon />}
        data-testid={QUESTION_REVIEW_TASK_DATA_TEST_ID.FINISH_TASK_BUTTON}
      >
        Finish Task
      </Button>
      <FinishQuestionReviewSubtaskModal
        open={isFinishSubtaskModalOpen}
        onClose={finishSubtaskModalHandler.close}
        onOverdue={handleSubtaskOverdue}
      />
      <FinishQuestionReviewMainTaskModal
        open={isFinishMainTaskModalOpen}
        onClose={finishMainTaskModalHandlers.close}
        onOverdue={handleMainTaskOverdue}
      />
      <TaskOverdueDialog
        variant={overdueVariant}
        open={isOverdueDialogOpen}
        onClose={overdueDialogHandlers.close}
      />
    </>
  );
}
